export interface ProductionAssignment {
  readonly id: string;
  readonly orderId: string;
  readonly assignedLabId: string | null;
  readonly productionPartnerId: string | null;
  readonly status: AssignmentStatus;
  readonly assignedDate: string;
  readonly completedDate: string | null;
  readonly notes: string | null;
  readonly workpieceId: string;
  readonly workpieceLabel: string;
  readonly stepName: string;
  readonly sequence: number;
  readonly technicianName: string | null;
  readonly completedAt: string | null;
  readonly startedAt: string | null;
}

export const AssignmentStatus = {
  Assigned: 'assigned',
  Accepted: 'accepted',
  InProgress: 'in_progress',
  Completed: 'completed',
} as const;
export type AssignmentStatus = (typeof AssignmentStatus)[keyof typeof AssignmentStatus];

export const ALL_ASSIGNMENT_STATUSES: readonly AssignmentStatus[] = [
  AssignmentStatus.Assigned,
  AssignmentStatus.Accepted,
  AssignmentStatus.InProgress,
  AssignmentStatus.Completed,
];

export const ASSIGNMENT_STATUS_LABELS: Readonly<Record<AssignmentStatus, string>> = {
  [AssignmentStatus.Assigned]: 'Assigned',
  [AssignmentStatus.Accepted]: 'Accepted',
  [AssignmentStatus.InProgress]: 'In progress',
  [AssignmentStatus.Completed]: 'Completed',
};
